/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface AdminUserSubscriptionCreateOrUpdateSupervisorLocationContactBody { 
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    departmentId: number;
    /**
     * 
     */
    locationId: string;
    /**
     * 
     */
    startDate: string;
    /**
     * 
     */
    endDate?: string;
    /**
     * 
     */
    type: AdminUserSubscriptionCreateOrUpdateSupervisorLocationContactBody.TypeEnum;
}
export namespace AdminUserSubscriptionCreateOrUpdateSupervisorLocationContactBody {
    export type TypeEnum = 'internship-evaluation-interuniversity' | 'supervisor-quality-survey';
    export const TypeEnum = {
        InternshipEvaluationInteruniversity: 'internship-evaluation-interuniversity' as TypeEnum,
        SupervisorQualitySurvey: 'supervisor-quality-survey' as TypeEnum
    };
}


